var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"value":_vm.value},on:{"change":_vm.inputHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }